import * as styles from './InputWrapHelp.module.css'

function InputWrapHelp({ className = styles.InputWrapHelp, text }) {
  return <span className={className}>{text}</span>
}

export default InputWrapHelp
